export class FilePartageParMailInput{
    idFichier = 0
    identifiantTelechargement = ''
    mail = ''
    corpsMail = ''
}